import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  SelectField,
  ReferenceField,
} from 'react-admin';
import { Pagination } from '../../Components';
import EvidenceFilters from './filters';
import { evidenceType, status } from '../../utils/choices';
import EvidenceAction from './actions';

const EvidenceList = (props) => (
  <List
    bulkActionButtons={false}
    exporter={false}
    filters={<EvidenceFilters />}
    actions={<EvidenceAction />}
    {...props}
    perPage={50}
    pagination={<Pagination />}
  >
    <Datagrid>
      <TextField source="name" label="Evidence name" sortable={false} />
      <SelectField source="type" choices={evidenceType} sortable={false} />
      <ReferenceField label="Plot" source="plotId.id" reference="plot">
        <TextField source="name" sortable={false} />
      </ReferenceField>
      <SelectField source="status" choices={status} sortable={false} />
      <EditButton/>
    </Datagrid>
  </List>
);

export default EvidenceList;
